export const STATE_PROP = 'entities'
